export default function Field({
  label,
  htmlFor,
  children,
  description,
  hint,
  error,
  required,
}) {
  return (
    <div className="flex flex-col gap-1.5">
      {label ? (
        <label
          htmlFor={htmlFor}
          className="text-[13px] font-semibold leading-tight text-[rgb(var(--fg))]"
        >
          {label}
          {required ? <span className="ml-1 text-xs text-[rgb(var(--brand))]">*</span> : null}
        </label>
      ) : null}
      <div className="flex flex-col gap-1">
        {children}
        {hint ? (
          <p className="text-xs text-[rgba(var(--muted),0.9)]">{hint}</p>
        ) : null}
        {description ? (
          <p className="text-xs text-[rgba(var(--muted),0.95)]">{description}</p>
        ) : null}
        {error ? (
          <p className="text-xs font-semibold text-[rgb(var(--brand-700))]" role="alert">
            {error}
          </p>
        ) : null}
      </div>
    </div>
  );
}
